import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {
    ApprovedEnrollment,
    ApprovedEnrollmentHistory,
    BudgetBillingReport,
    CompletionReport,
    EnrollmentReport,
    KeepingCurrentReportClient
} from './api.client';
import {MissedPaymentReport} from './api.client';
import {ConfirmOrphanReport} from './api.client';
import {toDate} from '../utilities/date-util';

@Injectable()
export class KcReportService {

    constructor(private _kcReportAPI: KeepingCurrentReportClient) {
    }

    buildConfirmOrphanReport(startDate: Date, endDate: Date, agencyId: string): Observable<ConfirmOrphanReport[]> {
        return this._kcReportAPI.buildConfirmOrphanReport(startDate, endDate, agencyId).pipe(share());
    }

    buildMissedPaymentReport(startDate: Date, endDate: Date, agencyId: string): Observable<MissedPaymentReport[]> {
        return this._kcReportAPI.buildMissedPaymentReport(startDate, endDate, agencyId).pipe(share());
    }

    buildEnrollmentReport(startDate: Date, endDate: Date, agencyId: string, statusIds: string)
        : Observable<EnrollmentReport[]> {
        return this._kcReportAPI.buildEnrollmentReport(startDate, endDate, agencyId, statusIds).pipe(share());
    }

    buildApprovedEnrollmentReport(exportDate: Date | string): Observable<ApprovedEnrollment[]> {
        return this._kcReportAPI.buildApprovedEnrollmentsReport(toDate(exportDate));
    }

    buildBudgetBillingReport(monthYear: string, agencyId: string): Observable<BudgetBillingReport[]> {
        return this._kcReportAPI.buildBudgetBillingReport(monthYear, agencyId);
    }

    buildCompletionReport(startMonthYear: string, endMonthYear: string, agencyId: string): Observable<CompletionReport[]> {
        return this._kcReportAPI.buildCompletionReport(startMonthYear, endMonthYear, agencyId);
    }

    setDownloadTimeStampForApprovalRecordedApplications(): Observable<void> {
        return this._kcReportAPI.setDownloadTimeStampForApprovalRecordedApplications().pipe(share());
    }

    getApprovedEnrollmentHistory(): Observable<ApprovedEnrollmentHistory[]> {
        return this._kcReportAPI.getApprovedEnrollmentHistory();
    }
}
